import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Shell des consultations (suivi académique, dossier médical, comportement…).
 *
 * <p>C'est une coquille de routage : les entrées du sous-menu sont des routes
 * enfants qui doivent s'afficher ici. Sans `<router-outlet>` elles ne se
 * rendaient jamais — l'écran montrait toujours le message d'accueil.</p>
 */
@Component({
  selector: 'app-consultation',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './consultation.component.html',
  styleUrl: './consultation.component.css',
})
export class ConsultationComponent {}
